import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';
import en from './en.json';

const STORAGE_KEY = 'catering.locale';

export const supportedLocales = ['ru', 'en'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

const initial = (): SupportedLocale => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'ru' || stored === 'en') return stored;
  return navigator.language.startsWith('en') ? 'en' : 'ru';
};

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: initial(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const changeLocale = (locale: SupportedLocale) => {
  localStorage.setItem(STORAGE_KEY, locale);
  void i18n.changeLanguage(locale);
};

export default i18n;
